import { Breadcrumb, Button, Card } from "antd";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import { useNavigate } from "react-router";
import { ReactComponent as TitleIcon } from "../../assests/images/settingsBreadCum.svg";
import AccountCard from "../../components/account-card";
import { useSelector } from "react-redux";
import { selectedAccountSelector } from "../../store/selectors/app.selector";
import { useRef } from "react";
import BANK_LOGO from "client/assets/LOGO/BANK_LOGO.png";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

export default function QrCodeComponent() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const selectedAccount = useSelector(selectedAccountSelector);
  const canvasRef = useRef(null);
  const containerRef = useRef(null);

  const handleSaveQRCode = () => {
    const canvas = canvasRef.current;
    if (!canvas) {
      console.error("Canvas element not found");
      return;
    }
    const context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
    const qrCodeHtml = containerRef.current.innerHTML;
    if (!qrCodeHtml) {
      console.error("QR code HTML not found");
      return;
    }
    const img = new Image();
    img.onload = function () {
      context.drawImage(img, 0, 0, 200, 200);
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = "qrcode.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
    img.src = "data:image/svg+xml," + encodeURIComponent(qrCodeHtml);
  };

  return (
    <div>
        <Breadcrumb separator=">" className="hide-xs">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/settings")}>
              {t("navigation.other", {
                defaultValue: "Other Services",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("navigation.qr", {
                defaultValue: "My QR Code",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("navigation.qr", {
                defaultValue: "My QR Code",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="row d-flex justify-content-between">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 hide-xs">
          <Card className="application-card"  >
            <AccountCard />
          </Card>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="application-card card-padding">
            <div align="center">
              <div className="mb-4">
                <img height={25} src={BANK_LOGO} alt="Bank Logo" />
              </div>
              <div className="mb-4">
                <b>
                  {t("pages.upload.scan_to_pay", {
                    defaultValue: "Scan to Pay",
                  })}
                </b>
              </div>
            </div>

            <canvas
              ref={canvasRef}
              width={200}
              height={200}
              style={{ display: "none" }}
            />
            <div ref={containerRef}>
              <QRCode
                size={200}
                value={selectedAccount?.accountNo}
                viewBox={`0 0 200 200`}
                style={{ maxWidth: "100%", width: "100%" }}
              />
            </div>
            <div className="mt-3" align="center">
              <div className="mb-2  w-100">
                <label>
                  {t("pages.upload.account_holder_name", {
                    defaultValue: "Account Holder's Name",
                  })}{" "}
                  : &nbsp;
                </label>
                <b>{selectedAccount?.accountName || "-"}</b>
              </div>
              <div className="mb-2  w-100">
                <label>
                  {t("common.account_no_lbl", {
                    defaultValue: "Account Number",
                  })}
                  : &nbsp;
                </label>
                <b>
                ********
                  {selectedAccount?.accountNo?.slice(
                    selectedAccount?.accountNo?.length - 4,
                    selectedAccount?.accountNo?.length
                  )}
                </b>
              </div>
            </div>

            <Button
              size="large"
              type="primary"
              className="mt-5"
              style={{ maxWidth: "100%", width: "100%" }}
              onClick={handleSaveQRCode}
            >
              {t("buttons.save_qr_code", {
                defaultValue: "Save QR Code",
              })}
            </Button>
          </Card>
        </div>
      </div>
    </div>
  );
}
